import { render, staticRenderFns } from "./DashInicialIndustria.vue?vue&type=template&id=7280f6b8&"
import script from "./DashInicialIndustria.vue?vue&type=script&lang=js&"
export * from "./DashInicialIndustria.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports